import { AiTemplatePreview } from '../../apiClients/AiTemplateClient';
import { Template } from '../../apiClients/TemplateClient';
import { ProfileGraph } from '../../apiClients/ProfileClient';
import { WeightSelection } from '../../models/dtos';

export const buildAiTemplatePreview = (
    graph: ProfileGraph,
    template: Template,
    jobDescription: string,
): AiTemplatePreview => ({
    PositionId: template.PositionId,
    TemplateName: template.Name,
    ProcessType: template.ProcessType,
    JobDescription: jobDescription ?? '',
    ProficiencyGroups: graph.TemplateRevision2ProficiencyGroupDisplays.map(group => ({
        ProficiencyGroup: group.ProficiencyGroupName,
        Weight: group.Weight,
        Proficiencies: graph.Proficiencies
            .filter(proficiency => proficiency.ProficiencyGroupId === group.ProficiencyGroupId)
            .map(proficiency => ({
                Description: proficiency.Name,
                Type: proficiency.Type,
                Weight: weightSelectionToNumber(proficiency.Weight),
                IsNegative: proficiency.IsNegative,
                ReusesExistingProficiency: false,
                ExistingProficiencyId: null,
                TemplateProficiencyId: proficiency.ProficiencyId,
            })),
    })),
    AssistantMessage: '',
    InteractionId: '',
});

export const weightSelectionToNumber = (weight: WeightSelection): number => {
    switch (weight) {
        case WeightSelection.LeastImportant: return 1;
        case WeightSelection.StandardLessThree: return 2;
        case WeightSelection.StandardLessTwo: return 3;
        case WeightSelection.StandardLessOne: return 4;
        case WeightSelection.Standard: return 5;
        case WeightSelection.StandardPlusOne: return 6;
        case WeightSelection.StandardPlusTwo: return 7;
        case WeightSelection.StandardPlusThree: return 8;
        case WeightSelection.StandardPlusFour: return 9;
        case WeightSelection.MostImportant: return 10;
        default: return 5;
    }
};

export const weightNumberToSelection = (weight: number): WeightSelection => {
    switch (weight) {
        case 1: return WeightSelection.LeastImportant;
        case 2: return WeightSelection.StandardLessThree;
        case 3: return WeightSelection.StandardLessTwo;
        case 4: return WeightSelection.StandardLessOne;
        case 5: return WeightSelection.Standard;
        case 6: return WeightSelection.StandardPlusOne;
        case 7: return WeightSelection.StandardPlusTwo;
        case 8: return WeightSelection.StandardPlusThree;
        case 9: return WeightSelection.StandardPlusFour;
        case 10: return WeightSelection.MostImportant;
        default: return WeightSelection.Standard;
    }
};
